import CountUp from 'countup.js';

export default class Counter {
    static init(wow, id, n) {
        return new Counter(wow, id, n);
    }

    constructor(wow, id, n) {
        let options = {
              useEasing : true, 
              useGrouping : true, 
              separator : '', 
              decimal : '.', 
              prefix : '', 
              suffix : '' 
        };
        let demo = new CountUp(id, 0, n, 0, 4.5, options);

        let wowCount = new wow(
            {
                boxClass: 'wowCount',
                callback: function(box) {
                    demo.start();
                }
            }
        );
        wowCount.init();
    }
}